import { ConstantVariables } from "../../../Helpers/ConstantVariables";
import { DataWarehouseDataService } from "../../../DataService/DataWarehouseDataService";
import { Toastr } from "../../../Helpers/Toastr";

export class ProcureShipAttachmentManager {

    constructor(private containerElement: JQuery) { }

    private attachmentsTable : JQuery<HTMLElement>;
    private attachmentsTableBody : JQuery<HTMLElement>;
    private addAttachmentButton : JQuery<HTMLElement>;
    private hiddenFileUploadButton : JQuery<HTMLElement>;

    private templateElement : JQuery<HTMLElement>;

    private docRevisionId;
    private docHeaderId;

    public initialize(docHeaderId : string, docRevisionId : string) {
        this.docHeaderId = docHeaderId;
        this.docRevisionId = docRevisionId;

        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        this.hiddenFileUploadButton = this.containerElement.find('#hidden-file-input');
        console.log(this.hiddenFileUploadButton);

        this.attachmentsTable = this.containerElement.find('#attachments-table');
        this.attachmentsTableBody = this.attachmentsTable.find('tbody');
        this.addAttachmentButton = this.containerElement.find('#add-attachment-button');

        this.templateElement = this.containerElement.find('#templates-attachment-row');
    }

    private bindEvents() {
        var self = this;

        self.addAttachmentButton.off('click').on('click', () => {
            self.addAttachmentButton.prop('disabled', true);
            self.hiddenFileUploadButton.trigger('click');
        });

        self.hiddenFileUploadButton.off('change').on('change', (args) => {
            var uploadedFile = (args.target as any).files[0];

            if(uploadedFile != undefined) {
                self.hiddenFileUploadButton.val('');

                var formData = new FormData();
                formData.append('file', uploadedFile);

                DataWarehouseDataService.uploadProcureShipAttachment(self.docHeaderId, self.docRevisionId, formData, (attachmentId) => {
                    if(attachmentId != '' && attachmentId != ConstantVariables.EmptyGuid) {
                        var newListItem = $(self.templateElement.html());

                        var fileDownloadInput = newListItem.find('#file-download-input');
                        fileDownloadInput.text(uploadedFile.name.split('.').shift());
                        fileDownloadInput.attr('download', uploadedFile.name);
        
                        var reader = new FileReader();
                  
                        reader.onload = function(e) {
                            fileDownloadInput.attr('href', e.target.result.toString());
                        }
                        
                        reader.readAsDataURL(uploadedFile); // convert to base64 string
        
                        this.bindAttachmentRow(newListItem, attachmentId);
        
                        self.attachmentsTableBody.append(newListItem);
        
                        
                    }
                    else {
                        Toastr.Error(`Couldn't add attachment`, `Due to an error we couldn't add the attachment. Please try again later`);
                    }

                    self.addAttachmentButton.prop('disabled', false);
                })



            }
        })

        self.hiddenFileUploadButton.off('cancel').on('cancel', () => {
            self.addAttachmentButton.prop('disabled', false);
        })

        self.attachmentsTableBody.find('tr').each((index, element) => {
            var listItemRow = $(element);
            var attachmentId = listItemRow.data('attachment-id');

            self.bindAttachmentRow(listItemRow, attachmentId);
        }) 
    }

    private bindAttachmentRow(row : JQuery<Element>, attachmentId: string) {
        var self = this;

        //TODO: Remove attachment
        var removeButton = row.find('#remove-button');
        removeButton.off('click').on('click', () => {
            removeButton.prop('disabled', true);
            DataWarehouseDataService.deleteProcureShipAttachment(self.docHeaderId, self.docRevisionId, attachmentId, (result) => {
                if(result) {
                    row.remove();
                }
                else {
                    Toastr.Error(`Couldn't delete attachment`, `Due to an error we couldn't delete the attachment. Please try again later`);
                    removeButton.prop('disabled', false);
                }
            })
        });

    }

}